import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import MriSimmonsLogo from '../components/common/MriSimmonsLogo';

import { getSimmonsBlogs, uniAccess } from '../actions/universityActions';

import UniAccessForm from '../components/University/UniAccessForm';
import SimmonsBlogs from '../components/University/SimmonsBlogs';
import { BETA_CATALYST_URL, BETA_HOST, LANDING_PAGE_URL, PROD_CATALYST_URL, PROD_HOST } from '../constants';

class ManageUniAccessPage extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  state = {
    blogs: [],
    blogError: false,
    error: false,
    loader: false,
  }

  UNSAFE_componentWillMount() {
    const { universityUser, userDetails } = this.props.user;
    let showLandingPage = universityUser && userDetails;
    if (!universityUser && userDetails) {
      showLandingPage = true;
    }

    if (showLandingPage) {
      const html = document.getElementsByTagName('html');
      html[0].classList.remove('university-page');
      this.context.router.push('/essentials/crosstab');
    } else {
      getSimmonsBlogs()
        .then(response => {
          if (response) {
            this.setState({ blogError: false, blogs: response });
          } else {
            this.setState({ blogError: true });
          }
        })
        .catch(() => {
          this.setState({ blogError: true });
        });
    }
  }

  handleProceed = () => {
    const { params } = this.props;
    const { uniID } = params;
    if (uniID) {
      this.setState({ loader: true });
      uniAccess(uniID)
      .then(res => {
        if (res.status === 'success') {
          this.setState({ error: '', loader: false }, () => {
            if (window.location.hostname.includes(PROD_HOST)) {
              window.location = `${PROD_CATALYST_URL}/v2`
            } else if (window.location.hostname.includes(BETA_HOST)) {
              window.location = `${BETA_CATALYST_URL}/v2`
            } else {
              window.location = LANDING_PAGE_URL
            }
          });
        } else {
          this.setState({ error: res.message, loader: false });
        }
      });
    } else {
      this.setState({ error: 'The School-specific URL you entered is incorrect. Please check that the URL is spelled correctly and try again.' });
    }
  }

  render() {
    const { error, loader, blogs } = this.state;
    return (
      <div className="uni-login fill-height">
        <div className="login-form">
          <div className="login-form-box">
            <div className="mri-simmons-logo">
              <MriSimmonsLogo height={65} width={330} />
            </div>
            <div className="login-box">
              <h1>Welcome to MRI-Simmons Catalyst</h1>
              {error && <div className="error">{error}</div>}
              <UniAccessForm
                loader={loader}
                handleProceed={this.handleProceed}
              />
            </div>
          </div>
          <div className="login-form-footer">
            <p>
              &copy; MRI-Simmons, {new Date().getFullYear()}. Proprietary and Confidential.<br />Need support? <a href="https://www.mrisimmons.com/about/contact/" target="_blank" rel="noopener noreferrer"><strong>Contact Us</strong></a>
            </p>
          </div>
        </div>
        <SimmonsBlogs blogs={blogs} />
        <ToastContainer />
      </div>
    );
  }
}

ManageUniAccessPage.propTypes = {
  user: PropTypes.shape({
    universityUser: PropTypes.bool,
    userDetails: PropTypes.bool,
  }),
  params: PropTypes.shape({}),
};

const mapStateToProps = ({ login }) => {
  const user = {
    universityUser: true,
    userDetails: false,
  };
  if (login.loginResponse) {
    user.universityUser = login.loginResponse.data.universityUser;
    user.userDetails = true;
  }
  return {
    user,
  };
};

export default connect(
  mapStateToProps,
  {},
)(ManageUniAccessPage);
